import React, { Component } from 'react';
import './../../assets/css/App.css';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableRowColumn from './../../component/table/table/TableRowColumn';
import TableHead from './../../component/table/table/TableHead';
import TableHeaderColumn from './../../component/table/table/TableHeaderColumn';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import DatePicker from './../../component/datePicker';
import AccountViewTypeEnum from './AccountViewTypeEnum';
import maskLoaderImg from './../../assets/images/loader.gif';

class TableView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Accounts sorted by revenue",
        pagingMetadata: [],
        responseTableData: {},
        showMask: false
    }

    constructor() {
        super();
        this.currentPage = 0;
        this.searchFieldValuesObject = {};
        this.createdDateStart = "";
        this.createdDateEnd = "";
        this.viewType = AccountViewTypeEnum.AccountSortByRevenue
    }

    componentDidMount () {
        Service.event.onAccountsSortByRevenue.add((data) => {
            console.log("Fetch data");
            console.log(data);
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }
    // private
    _callServiceFetch(page) {
        this.setState({
            showMask: true
        });

        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        Service.fetchCannedAccountReport(page, searchParams, this.viewType).finally(() => {
            this.setState({ showMask: false });
        });
    }

    // private
    _callServiceDownloadFile() {
        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        Service.downloadCannedAccountReport(searchParams, this.viewType);
    }

    onStartDateFieldChange = (value) => {
        console.log("On Start Date Input Change in the parent");
        console.log(value);
        this.createdDateStart = value;
    };

    onEndDateFieldChange = (value) => {
        console.log("On End Date Input Change in the parent");
        console.log(value);
        this.createdDateEnd = value;
    };

    // table actions
    searchButtonAction = () => {
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToPage = (e) => {
        e.preventDefault();
        var page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        //Service.fetchAccountsWithoutSendShipment(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        console.log("Table Widget GO FORWARD");
        console.log(this.currentPage);
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            //Service.fetchAccountsWithoutSendShipment(this.currentPage);
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        console.log("Table Widget GO Back");
        console.log(this.currentPage);
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            //Service.fetchAccountsWithoutSendShipment(this.currentPage);
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

    downloadFileAction = () => {
        this._callServiceDownloadFile();
    };

    createTableRowColumns = () => {
        var rowColumnComponentList = [];
        if (this.state.responseTableData.results !== undefined) {
            if (this.state.showMask) {
                rowColumnComponentList.push(<tr key="1"><td colSpan="9"><img src={maskLoaderImg} className="centerSpinnerImage"/></td></tr>);
            } else {
                rowColumnComponentList = this.state.responseTableData.results.map(function (item, index) {
                    var rowColumnComponent = {};
                    rowColumnComponent = <tr key={index}>
                        <TableRowColumn>{item.accountId}</TableRowColumn>
                        <TableRowColumn>{item.lockerCode}</TableRowColumn>
                        <TableRowColumn>{item.firstName}</TableRowColumn>
                        <TableRowColumn>{item.lastName}</TableRowColumn>
                        <TableRowColumn>{item.countryName}</TableRowColumn>
                        <TableRowColumn>{item.createdDate}</TableRowColumn>
                        <TableRowColumn>{item.accountRole}</TableRowColumn>
                        <TableRowColumn>{item.totalRevenue}</TableRowColumn>
                    </tr>
                    return rowColumnComponent;
                });
            }
        } else {
            if (this.state.showMask) {
                rowColumnComponentList.push(<tr key="1"><td colSpan="9"><img src={maskLoaderImg} className="centerSpinnerImage"/></td></tr>);
            } else {
                rowColumnComponentList.push(<tr key="0"><td colSpan="9">{this.state.emptyTableMessage}</td></tr>);
            }
        }
        return rowColumnComponentList;
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        downloadFileAction = {this.downloadFileAction}
                        selectDropdownValues = {this.selectDropdownloIntervalValuesForThreeMonth}
                        type = "cannedReport"
                    >
                        <DatePicker
                            fieldId = "accountSortByRevenueStartDatePicker"
                            placeHolderText = "Start Date"
                            onChange = {this.onStartDateFieldChange}
                            fieldType = "startDate"
                        ></DatePicker>
                        <DatePicker
                            fieldId = "accountSortByRevenueEndDatePicker"
                            placeHolderText = "End Date"
                            onChange = {this.onEndDateFieldChange}
                            fieldType = "endDate"
                        ></DatePicker>
                    </TableSearchHeader>
                   <TableHead>
                       <tr>
                           <TableHeaderColumn>Account Id</TableHeaderColumn>
                           <TableHeaderColumn>Locker</TableHeaderColumn>
                           <TableHeaderColumn>First Name</TableHeaderColumn>
                           <TableHeaderColumn>Last Name</TableHeaderColumn>
                           <TableHeaderColumn>Country</TableHeaderColumn>
                           <TableHeaderColumn>Date Joined</TableHeaderColumn>
                           <TableHeaderColumn>Roles</TableHeaderColumn>
                           <TableHeaderColumn>Total Revenue</TableHeaderColumn>
                       </tr>
                   </TableHead>
                   <TableBody>
                           {this.createTableRowColumns()}
                   </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        goForwardToPage={this.goForwardToPage}
                        goBackToPage={this.goBackToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;